import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/views/Home/index.vue'
import gyhy from '@/views/Gyhy/index.vue'
import cpyfw from '@/views/cpyfw/index.vue'
import pzyaq from '@/views/pzyaq/index.vue'
import gcyj from '@/views/gcyj/index.vue'
import zxxx from '@/views/zxxx/index.vue'

import homeen from '@/views/Home_en/index.vue'
import gyhyen from '@/views/Gyhy_en/index.vue'
import cpyfwen from '@/views/cpyfw_en/index.vue'
import pzyaqen from '@/views/pzyaq_en/index.vue'
import gcyjen from '@/views/gcyj_en/index.vue'
import zxxxen from '@/views/zxxx_en/index.vue'

import homejp from '@/views/Home_jp/index.vue'
import gyhyjp from '@/views/Gyhy_jp/index.vue'
import cpyfwjp from '@/views/cpyfw_jp/index.vue'
import pzyaqjp from '@/views/pzyaq_jp/index.vue'
import gcyjjp from '@/views/gcyj_jp/index.vue'
import zxxxjp from '@/views/zxxx_jp/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: { lang: '"zn"' },
  },
  {
    path: '/',
    redirect: function () {
      const lang = localStorage.getItem('Language')
      if (lang == '"zn"') {
        return '/home'
      } else if (lang == '"jp"') {
        return '/homejp'
      } else {
        return '/homeen'
      }
    },
  },
  {
    path: '/gyhy',
    name: 'gyhy',
    component: gyhy,
  },
  {
    path: '/cpyfw',
    name: 'cpyfw',
    component: cpyfw,
  },
  {
    path: '/pzyaq',
    name: 'pzyaq',
    component: pzyaq,
  },
  {
    path: '/gcyj',
    name: 'gcyj',
    component: gcyj,
  },
  {
    path: '/zxxx',
    name: 'zxxx',
    component: zxxx,
  },
  {
    path: '/homeen',
    name: 'homeen',
    component: homeen,
    meta: { lang: '"en"' },
  },
  {
    path: '/gyhyen',
    name: 'gyhyen',
    component: gyhyen,
  },
  {
    path: '/cpyfwen',
    name: 'cpyfwen',
    component: cpyfwen,
  },
  {
    path: '/pzyaqen',
    name: 'pzyaqen',
    component: pzyaqen,
  },
  {
    path: '/gcyjen',
    name: 'gcyjen',
    component: gcyjen,
  },
  {
    path: '/zxxxen',
    name: 'zxxxen',
    component: zxxxen,
  },
  {
    path: '/homejp',
    name: 'homejp',
    component: homejp,
    meta: { lang: '"jp"' },
  },
  {
    path: '/gyhyjp',
    name: 'gyhyjp',
    component: gyhyjp,
  },
  {
    path: '/cpyfwjp',
    name: 'cpyfwjp',
    component: cpyfwjp,
  },
  {
    path: '/pzyaqjp',
    name: 'pzyaqjp',
    component: pzyaqjp,
  },
  {
    path: '/gcyjjp',
    name: 'gcyjjp',
    component: gcyjjp,
  },
  {
    path: '/zxxxjp',
    name: 'zxxxjp',
    component: zxxxjp,
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history', // 添加这一行
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

// 全局前置守卫：根据路由自动设置语言
router.beforeEach((to, from, next) => {
  if (
    to.fullPath === '/homeen' ||
    to.fullPath === '/home' ||
    to.fullPath === '/homejp'
  ) {
    const lang = to.meta.lang || 'en' // 从路由meta获取语言
    localStorage.setItem('Language', lang) // 存储到localStorage
    next()
  } else {
    next()
  }
})

export default router
